import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { BancoNoticiasService } from "src/app/services/banco-noticias.service";
import { obterBancoNoticias, obterBancoNoticiasFailure, obterBancoNoticiasSuccess } from "../../actions/BancoNoticias/obter-banco-noticias.action";

@Injectable()
export class ObterBancoNoticiasEffects {

  public obterBancoNoticias$: unknown;

  constructor(private readonly actions$: Actions,
    private readonly bancoNoticiasService: BancoNoticiasService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterBancoNoticias$ = createEffect(() => this.actions$.pipe(
      ofType(obterBancoNoticias),
      switchMap(({ inputDto }) =>
        this.bancoNoticiasService
          .obterBancoNoticias(inputDto)
          .pipe(
            map(
              response => {
              if (response.erros != undefined && response.erros.length > 0) {
                return obterBancoNoticiasFailure({ response })
              }
              return obterBancoNoticiasSuccess({ response })
            }),
            catchError(() => {
              return of()}
            )
          )
      )
    )
    );
  }
}
